import React, { useEffect, useState } from 'react'
import { scrollAppToTop } from '../utils/scrollToTop'
import { Container, Grid, Image, Header, Icon, Segment } from "semantic-ui-react"
import '../styles/article.css'
import UserFlowDiagram from './UserFlowDiagram'
import libraryTornado from '../assets/libraryTornado_a.png'

export default function UserFlowDiagramContainer() {
  const [activeView, setActiveView] = useState('full') // full, bookCreator, voiceActor

  useEffect(() => {
    // This page renders `.std-pg-main-area`, a fixed 100vh box with its own overflow-y: scroll,
    // so its content has never scrolled the document — `window.scrollTo` was inert here even
    // before the layout change. scrollAppToTop targets the page's own box.
    scrollAppToTop()
  }, [])

  return (
    <div className="std-pg-main-area std-pg-grey-background-color">
      <Container style={{ marginTop: "30px", marginBottom: "200px" }}>
        {/* Header Section */}
        <Grid className="articleListWidth">
          <Grid.Row>
            <Grid.Column width={3}>
              <div className="img-with-gradient">
                <Image src={libraryTornado} />
              </div>
            </Grid.Column>
            <Grid.Column width={13} textAlign="center">
              <span className="blgListItemTitle">
                <Icon name="sitemap" /> Marketplace User Flow
              </span>
              <span className="blgListSubTitle">
                Visual Guide to Book Creator & Voice Actor Interactions
              </span>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        {/* View Toggle Section */}
        <Segment basic textAlign="center" style={{ marginTop: "20px" }}>
          <Header as="h3" color="grey">
            <Icon name="eye" />
            Select View Mode
          </Header>
          <div className="view-toggle-buttons">
            <button
              className={`view-toggle-btn ${activeView === 'full' ? 'active' : ''}`}
              onClick={() => setActiveView('full')}
            >
              <Icon name="th" /> Full Flow
            </button>
            <button
              className={`view-toggle-btn ${activeView === 'bookCreator' ? 'active' : ''}`}
              onClick={() => setActiveView('bookCreator')}
            >
              <Icon name="book" /> Book Creator Only
            </button>
            <button
              className={`view-toggle-btn ${activeView === 'voiceActor' ? 'active' : ''}`}
              onClick={() => setActiveView('voiceActor')}
            >
              <Icon name="microphone" /> Voice Actor Only
            </button>
          </div>
        </Segment>

        {/* Main Flow Diagram */}
        <Grid className="articleListWidth" style={{ marginTop: "20px", borderTop: "solid 1px #AAAAAA" }}>
          <UserFlowDiagram activeView={activeView} />
        </Grid>
      </Container>
    </div>
  )
}
